import { Dispatch, SetStateAction, useState } from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchBar from "../../components/SearchBar";
import { useNavigate } from "react-router-dom";

const RolesListTopbar = ({
  setDebouceSearchTerm,
  searchTerm,
  setSearchTerm,
}: {
  searchTerm: string;
  setDebouceSearchTerm: Dispatch<SetStateAction<string>>;
  setSearchTerm: Dispatch<SetStateAction<string>>;
}) => {
  const navigate = useNavigate();

  return (
    <>
      <div className="table_header">
        <div className="left_s">
          <Box className="search_box">
            <SearchBar
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              setDebouncedSearchTerm={setDebouceSearchTerm}
              placeholder="Search..."
            />
          </Box>
        </div>
        <div className="right_s">
          <Button
            className="btn btn_primary"
            onClick={() => navigate("/manage-subadmin/roles/add")}
          >
            <AddIcon /> Add Role
          </Button>
        </div>
      </div>
    </>
  );
};

export default RolesListTopbar;
